import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';
//import EventEmitter from '../utils/emmiter';

import '../djarea/css/sidemenu.css';


export default class DJAreaSideMenu extends React.Component {
  //static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {};
  };

  //loading:any = React.createRef();
  
  async componentDidMount() {
	}

	componentWillUnmount() {
	}


	

	render() {
		
		return (
			<div className="djarea-sidemenu-inner">
				<ul>
					<li><Link to="/admin" className={window.location.pathname==='/admin'?'sidemenu-active':''}>Admin</Link></li>
					<li><Link to="/admin/djaccounts" className={window.location.pathname==='/admin/djaccounts'?'sidemenu-active':''}>DJ Accounts</Link></li>
					<li><Link to="/admin/events" className={window.location.pathname==='/admin/events'?'sidemenu-active':''}>Events</Link></li>
					<li><Link to="/admin/weekly" className={window.location.pathname==='/admin/weekly'?'sidemenu-active':''}>Weekly Sets</Link></li>
					<li><Link to="/admin/publish" className={window.location.pathname==='/admin/publish'?'sidemenu-active':''}>Publish Sets</Link></li>
					<li><Link to="/admin/previous" className={window.location.pathname==='/admin/previous'?'sidemenu-active':''}>Rtmp</Link></li>
					<li><Link to="/admin/seo" className={window.location.pathname==='/admin/seo'?'sidemenu-active':''}>SEO</Link></li>
					<li><Link to="/admin/auth" className={window.location.pathname==='/admin/auth'?'sidemenu-active':''}>Authentication</Link></li>

				</ul>
			</div>
		);
	}
}
